var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statusEvent"},[_vm._v(" "+_vm._s(_vm.$t('message.user_changed_room_history',{user: _vm.eventSenderDisplayName(_vm.event), type: _vm.history(_vm.event)}))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }